export default __webpack_public_path__ + "static/media/icon-folder-common.862b63e9.svg";